import { gql } from '@apollo/client';

/** 可清理表白名单（后端枚举，界面只能从中选择） */
export interface RetainableTableItem {
  name: string;
  tableName: string;
  timeColumn: string;
  minRetentionDays: number;
  defaultRetentionDays: number;
  defaultBatchSize: number;
  description: string;
}

export interface DataRetentionPolicyItem {
  id: string;
  target: string;
  tableName: string;
  timeColumn: string;
  retentionDays: number;
  /** 实际生效天数 = max(配置值, 代码下限)，与 retentionDays 不同时说明配置被下限兜底了 */
  effectiveRetentionDays: number;
  minRetentionDays: number;
  batchSize: number;
  maxBatchesPerRun: number;
  batchDelayMs: number;
  isActive: boolean;
  remark: string | null;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface PendingCleanupPreviewItem {
  pendingRows: number;
  /** true 表示实际数量超过统计上限，界面应显示「N+」 */
  capped: boolean;
}

export interface DataRetentionExecutionItem {
  id: string;
  taskName: string;
  /** 1-初始化，2-运行中，3-成功，4-失败 */
  status: number;
  startedAt: string | null;
  endedAt: string | null;
  message: string | null;
  hostname: string | null;
}

export interface ListRetainableTablesResponse {
  listRetainableTables: RetainableTableItem[];
}

export interface ListDataRetentionPoliciesResponse {
  listDataRetentionPolicies: DataRetentionPolicyItem[];
}

export interface PreviewDataRetentionCleanupResponse {
  previewDataRetentionCleanup: PendingCleanupPreviewItem;
}

export interface ListDataRetentionExecutionsResponse {
  listDataRetentionExecutions: DataRetentionExecutionItem[];
}

const POLICY_FIELDS = `
  id
  target
  tableName
  timeColumn
  retentionDays
  effectiveRetentionDays
  minRetentionDays
  batchSize
  maxBatchesPerRun
  batchDelayMs
  isActive
  remark
  description
  createdAt
  updatedAt
`;

export const LIST_RETAINABLE_TABLES = gql`
    query ListRetainableTables {
        listRetainableTables {
            name
            tableName
            timeColumn
            minRetentionDays
            defaultRetentionDays
            defaultBatchSize
            description
        }
    }
`;

export const LIST_DATA_RETENTION_POLICIES = gql`
    query ListDataRetentionPolicies {
        listDataRetentionPolicies {${POLICY_FIELDS}}
    }
`;

export const PREVIEW_DATA_RETENTION_CLEANUP = gql`
    query PreviewDataRetentionCleanup($id: String!) {
        previewDataRetentionCleanup(id: $id) {
            pendingRows
            capped
        }
    }
`;

export const LIST_DATA_RETENTION_EXECUTIONS = gql`
    query ListDataRetentionExecutions($id: String!, $limit: Int!) {
        listDataRetentionExecutions(id: $id, limit: $limit) {
            id
            taskName
            status
            startedAt
            endedAt
            message
            hostname
        }
    }
`;

export const CREATE_DATA_RETENTION_POLICY = gql`
    mutation CreateDataRetentionPolicy($input: CreateDataRetentionPolicyGqlInput!) {
        createDataRetentionPolicy(input: $input) {${POLICY_FIELDS}}
    }
`;

export const UPDATE_DATA_RETENTION_POLICY = gql`
    mutation UpdateDataRetentionPolicy($input: UpdateDataRetentionPolicyGqlInput!) {
        updateDataRetentionPolicy(input: $input) {${POLICY_FIELDS}}
    }
`;

export const SET_DATA_RETENTION_POLICY_ACTIVE = gql`
    mutation SetDataRetentionPolicyActive($id: String!, $isActive: Boolean!) {
        setDataRetentionPolicyActive(id: $id, isActive: $isActive) {${POLICY_FIELDS}}
    }
`;

export const DELETE_DATA_RETENTION_POLICY = gql`
    mutation DeleteDataRetentionPolicy($id: String!) {
        deleteDataRetentionPolicy(id: $id)
    }
`;

export const TRIGGER_DATA_RETENTION_CLEANUP = gql`
    mutation TriggerDataRetentionCleanup($id: String!) {
        triggerDataRetentionCleanup(id: $id)
    }
`;
